function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L50 0L50 50L0 50L0 0Z",
  id: "c++_path_1"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "c++_mask_1"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#c++_path_1"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "c-logo-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L50 0L50 50L0 50L0 0Z",
  id: "c-logo-1-(Background/Mask)",
  fill: "none",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#c++_mask_1)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1.59973 0C0.716199 0 0 0.716358 0 1.59973L0 48.4003C0 49.2836 0.716199 50 1.59973 50L48.4003 50C49.2838 50 50 49.2836 50 48.4003L50 1.59973C50 0.716358 49.2838 0 48.4003 0L1.59973 0ZM14.0663 32.9789C9.56974 32.9789 5.91148 29.3955 5.91148 24.9908C5.91148 20.5963 9.56974 17.0213 14.0663 17.0213C16.0702 17.0213 18.0011 17.7459 19.5033 19.0619C20.123 19.6045 20.1852 20.5469 19.6424 21.1665C19.0996 21.7862 18.1574 21.8485 17.5377 21.3055C16.5797 20.4664 15.3468 20.0041 14.0663 20.0041C11.2144 20.0041 8.89433 22.241 8.89433 24.9908C8.89433 27.7505 11.2144 29.9957 14.0663 29.9957C15.3448 29.9957 16.5845 29.5268 17.5572 28.6758C18.1771 28.133 19.1193 28.1962 19.6618 28.8161C20.2043 29.4361 20.1415 30.3785 19.5216 30.9208C18.0049 32.248 16.0675 32.9789 14.0663 32.9789ZM26.7414 26.4915L26.7414 29.4974C26.7414 30.3211 26.0737 30.9888 25.2498 30.9888C24.4259 30.9888 23.7582 30.3211 23.7582 29.4974L23.7582 26.4915L20.7526 26.4915C19.9289 26.4915 19.2611 25.8238 19.2611 25.0001C19.2611 24.1764 19.9288 23.5087 20.7526 23.5087L23.7582 23.5087L23.7582 20.5029C23.7582 19.6792 24.4259 19.0115 25.2498 19.0115C26.0737 19.0115 26.7414 19.6792 26.7414 20.5029L26.7414 23.5087L29.7471 23.5087C30.5708 23.5087 31.2387 24.1764 31.2387 25.0001C31.2387 25.8238 30.571 26.4915 29.7471 26.4915L26.7414 26.4915ZM39.5912 26.4915L39.5912 29.4974C39.5912 30.3211 38.9235 30.9888 38.0996 30.9888C37.2759 30.9888 36.608 30.3211 36.608 29.4974L36.608 26.4915L33.6025 26.4915C32.7788 26.4915 32.1109 25.8238 32.1109 25.0001C32.1109 24.1764 32.7786 23.5087 33.6025 23.5087L36.608 23.5087L36.608 20.5029C36.608 19.6792 37.2758 19.0115 38.0996 19.0115C38.9233 19.0115 39.5912 19.6792 39.5912 20.5029L39.5912 23.5087L42.5969 23.5087C43.4206 23.5087 44.0885 24.1764 44.0885 25.0001C44.0885 25.8238 43.4208 26.4915 42.5969 26.4915L39.5912 26.4915Z",
  id: "Vector",
  fill: "#FFFFFF",
  fillRule: "evenodd",
  stroke: "none"
})));

var SvgC = function SvgC(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgC, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/c++.2593201f.svg";
export { ForwardRef as ReactComponent };